import { render } from "./DojoReport.vue?vue&type=template&id=52b19ca2"
import script from "./DojoReport.vue?vue&type=script&lang=js"
export * from "./DojoReport.vue?vue&type=script&lang=js"

import "./DojoReport.vue?vue&type=style&index=0&id=52b19ca2&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__